// extracted by mini-css-extract-plugin
export default {"container":"TablesToggle_container__LaqE9","buttons":"TablesToggle_buttons__mzYya","active":"TablesToggle_active__dgCgi"};